import { Plugin } from 'grapesjs';

const ButtonPlugin: Plugin = (editor, opts = {}) => {
	const options = {
		blockLabel: 'Button',
		blockCategory: 'Basic',
		blockContent: {
			type: 'button',
			content: 'Click Me',
			attributes: { 'href': '#', 'data-gjs-type': 'button' },
			style: {
				'display': 'inline-block',
				'padding': '10px 20px',
				'background-color': '#008cba',
				'color': '#fff',
				'text-decoration': 'none',
				'border-radius': '5px',
				'cursor': 'pointer',
				'text-align': 'center',
			},
		},
		...opts,
	};

	const bm = editor.BlockManager;
	bm.add('custom-button', {
		label: options.blockLabel,
		category: options.blockCategory,
		media: `<svg width="75" height="30" viewBox="0 0 200 80" style="transform: scale(1); transform-origin: top left;" xmlns="http://www.w3.org/2000/svg">
			<rect x="10" y="10" width="180" height="60" rx="10" fill="#b8b8b8ff" stroke="#606060ff" stroke-width="3"/>
			<text x="50%" y="50%" font-family="Arial" font-size="20" fill="white" text-anchor="middle" dominant-baseline="middle">Click Me</text>
		</svg>`,
		content: options.blockContent,
	});

	editor.DomComponents.addType('button', {
		isComponent: (el) =>
			el.tagName === 'A' && el.getAttribute('data-gjs-type') === 'button'
				? { type: 'button' }
				: undefined,
		model: {
			defaults: {
				tagName: 'a',
				components: [{ type: 'textnode', content: 'Click Me' }],
				attributes: { 'href': '#', 'data-gjs-type': 'button' },
				style: {
					'display': 'inline-block',
					'padding': '10px 20px',
					'background-color': '#008cba',
					'color': '#fff',
					'text-decoration': 'none',
					'border-radius': '5px',
					'cursor': 'pointer',
					'text-align': 'center',
				},
				traits: [
					{
						type: 'text',
						label: 'Text',
						name: 'content',
						changeProp: true,
					},
					{ type: 'text', label: 'Link URL', name: 'href' },
					{
						type: 'color',
						label: 'Background Color',
						name: 'background-color',
						changeProp: true,
					},
					{
						type: 'color',
						label: 'Text Color',
						name: 'color',
						changeProp: true,
					},
				],
			},
			init() {
				this.on('change:content', () => {
					const newContent = this.get('content');
					const comps = this.components();
					if (comps.length) {
						comps.each((comp) => {
							if (comp.is('textnode'))
								comp.set('content', newContent);
						});
					} else {
						this.components().reset([
							{ type: 'textnode', content: newContent },
						]);
					}
				});
			},
		}
	});
};

export default ButtonPlugin;
